// extracted by mini-css-extract-plugin
export const button = "Button-module--button--2t432";
export const primary_extra = "Button-module--primary_extra--30_Td";
export const primary = "Button-module--primary--1Znlo";
export const blue = "Button-module--blue--2Tn0e";
export const green = "Button-module--green--36UD1";
export const white = "Button-module--white--2Xn31";
export const secondary = "Button-module--secondary--2lup3";